import { fetchJsonByDelete, fetchJsonByGet, fetchJsonByPut } from './execute';
import { fromGroup, fromGroupFix } from '../converters/permissionsConverter';
import { getParams } from '../reducers/analyticsApp';

// Все данные текущего пользователя одним запросом: permissionsByTenant (карта tenant -> permissions),
// sessionExpiresAt и т.д. Также служит probe сессии: успех = валидная OIDC-cookie, иначе 401.
export const fetchMe = () => (dispatch, getState) =>
  fetchJsonByGet('/authorization/me', getParams(getState()));

export const fetchGroups = () => (dispatch, getState) =>
  fetchJsonByGet('/authorization/groups', getParams(getState())).then((response) => ({
    groups: response.map(fromGroup),
  }));

export const saveGroup = (group) => (dispatch, getState) =>
  fetchJsonByPut('/authorization/groups', group, getParams(getState())).then((response) => ({
    group: fromGroupFix(response),
  }));

export const deleteGroup = (groupId) => (dispatch, getState) =>
  fetchJsonByDelete(`/authorization/groups/${groupId}`, getParams(getState())).then((response) => ({
    groupId: response.name,
  }));
